import { Navigate, Outlet } from 'react-router';
import type { ModuleKey } from '@bill-alps/backend/features/companies/modules';
import { useCurrentUser } from '@/hooks/use-current-user';
import { PageLoader } from './page-loader';

export function ModuleWriteGate({ module }: { module: ModuleKey }) {
  const { isLoading, canWriteModule } = useCurrentUser();
  if (isLoading) return <PageLoader />;
  if (!canWriteModule(module)) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
